// Register your feature flags here with a key for localStorage and a title
export const flags = {
  feature_extend_TTL: 'Extend TTL for lab users',
  feature_track_dashboard: 'Track Dashboard',
  feature_create_checks: 'Checks creation mode',
};
